import { useState } from 'react'
import Button from 'src/components/buttons/button'
import Card, { CardRule } from 'src/components/containers/card'
import { Table } from 'src/types/types'

import { ProductPolicies } from '../product-policies'

export const SharingPoliciesCard = ({ table }: { table: Table }) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <Card className='w-full' padding='none' overflow='visible'>
      <div>
        <div className='flex items-center justify-between p-6 text-sm font-bold'>
          <h4>Data Filtering</h4>
          <div className='flex gap-2'>
            <Button
              kind='icon'
              size='small'
              icon={expanded ? 'chevron-up' : 'chevron-down'}
              label='Toggle data filtering details'
              onClick={() => setExpanded(!expanded)}
            />
          </div>
        </div>
        {expanded && (
          <div>
            <CardRule />
            <ProductPolicies table={table} />
          </div>
        )}
      </div>
    </Card>
  )
}
